<script setup lang="ts">
import { BoxComponent } from '@/ui-library'
</script>

<template>
  <BoxComponent class="page-wrapper" :pt="32" :pl="32" :pr="32" :pb="96">
    <slot />
  </BoxComponent>
</template>

<style scoped lang="scss">
.page-wrapper {
  overflow: auto;
  position: relative;
  min-height: calc(100vh - 72px);
  max-width: 1264px;
  margin: 0 auto;
}
</style>
